import { render, staticRenderFns } from "./reversal.vue?vue&type=template&id=75d2f929&"
import script from "./reversal.vue?vue&type=script&lang=js&"
export * from "./reversal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports